<template>
    <span>
        <template v-if="editing">
            <b-input v-model="current" :size="size" :placeholder="placeholder" />

            <div class="mt-1">
                <button @click="editField" :disabled="saving" class="btn btn-xs btn-success"><i class="fa fa-check"></i></button>
                <button @click="cancelEditing" :disabled="saving" class="btn btn-xs btn-secondary"><i class="fa fa-times"></i></button>
            </div>
        </template>
        <template v-else>
            {{ current ? `${current}  ` : ''}}<a href="javascript:void(0)" @click="beginEditing"><i class="fa fa-edit"></i></a>
        </template>
    </span>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: '',
            },

            url: {
                type: String,
                required: false,
            },

            startEditing: {
                type: Boolean,
                default: false,
            },

            size: {
                type: String,
                default: ""
            },

            placeholder: {
                type: String,
                default: ""
            },
        },

        data: function() {
            return {
                saving: false,
                editing: false,
                original: null,
                current: null,
            }
        },

        methods: {
            beginEditing() {
                this.editing = true;

                // Set the original so we can roll back if needed
                this.original = this.current;
            },

            cancelEditing() {
                // Undo the changes
                this.current = this.original;

                this.editing = false;
            },

            editField(field) {
                if (this.url)
                {
                this.saving = true;
                //Send it
                this.$http.post(this.url, {value: this.current})
                    .then(res => {
                            //Alert the user
                            this.$toastr.success('Field Saved');

                            this.$emit('input', this.current);

                            this.editing = false;
                    })
                    .catch(res => {

                    })
                    .then(res => {
                            //Alert the user
                            this.saving = false;
                    });
                }
                else
                {
                    this.$emit('input', this.current);

                    this.editing = false;
                }
            },
        },

        mounted() {
            this.current = this.value;
            this.editing = this.startEditing;
        }
    }
</script>